import { hasClass } from '@opten/dom/has-class';
import { addClass } from '@opten/dom/add-class';
import { removeClass } from '@opten/dom/remove-class';
import { Component } from '@opten/compiler/metadata/component';
import { eventNamespaceFactory } from '@opten/events/event-namespace-factory';

export class SidePanelElement{
	element: HTMLElement;
	openElement: HTMLElement;
	closeElements: HTMLElement[];
	isOpen: boolean;
}

export class SidePanelOptions{
	sidePanelClass?: string;
	openElementClass?: string;
	closeElementClass?: string;
	outClass?: string;
	hideClass?: string;
}

@Component({ className: 'js-side-panel-wrapper' })
export class SidePanelComponent{
	private sidePanelWrapper: HTMLElement;
	private sidePanels: SidePanelElement[] = [];
	private options: SidePanelOptions = {
			sidePanelClass: 'js-side-panel',
			openElementClass: 'js-side-panel-open',
			closeElementClass: 'js-side-panel-close',
			outClass: 'is--slided-out',
			hideClass: 'd-none'
	}

	private eventNamespaceFn = eventNamespaceFactory('opten.sidePanel');


	constructor(element: HTMLElement){
		this.sidePanelWrapper = element;
		this.initSidePanels();
	}

	private initSidePanels(){
		const sidePanelElements = Array.from(this.sidePanelWrapper.querySelectorAll(
			`.${this.options.sidePanelClass}`
		)) as HTMLElement[];

		if(sidePanelElements && sidePanelElements.length > 0){
			sidePanelElements.forEach(sidePanelElement => {
				const openPanel = sidePanelElement.querySelector(
					`.${this.options.openElementClass}`
				) as HTMLElement;
				const closePanels = Array.from(sidePanelElement.querySelectorAll(
					`.${this.options.closeElementClass}`
				)) as HTMLElement[];
				const sidePanel: SidePanelElement= {
					element: sidePanelElement,
					openElement: openPanel,
					closeElements: closePanels,
					isOpen: false
				}
				if(openPanel){
					openPanel.addEventListener('click', () => this.showPanel(sidePanel) ) ;
				}
				if(closePanels){
					closePanels.forEach(o => o.addEventListener('click', ()=> this.hidePanel(sidePanel)));
				}
				this.sidePanels.push(sidePanel);
			})
		}
	}

	private showPanel(sidePanel: SidePanelElement){
		removeClass(sidePanel.element,this.options.outClass);
		this.eventNamespaceFn(this.sidePanelWrapper, 'open');

		this.sidePanels
		.filter(o => hasClass(o.element,this.options.outClass))
		.forEach(o => addClass(o.openElement,this.options.hideClass));

	}
	private hidePanel(sidePanel: SidePanelElement){
		addClass(sidePanel.element,this.options.outClass);
		this.eventNamespaceFn(this.sidePanelWrapper, 'close');

		this.sidePanels
		.filter(o => hasClass(o.element,this.options.outClass))
		.forEach(o => removeClass(o.openElement,this.options.hideClass));
	}
}